import request from "../utils/request";

export default {
	__getList() {
		return request({
			url: `product/list`,
			method: "GET"
		});
	},
	__getOnSaleList() {
		return request({
			url: `product/on-sale-list`,
			method: "GET"
		});
	},
	__getData(id) {
		return request({
			url: `product/${id}`,
			method: "GET"
		});
	},
	__createData(data) {
		return request({
			url: `product/new`,
			method: "POST",
			data
		});
	},
	__updateData({ id, data }) {
		return request({
			url: `product/${id}`,
			method: "PUT",
			data
		});
	},
	__sortList(data) {
		return request({
			url: `product/sort`,
			method: "PUT",
			data
		});
	},
	__removeData(id) {
		return request({
			url: `product/${id}`,
			method: "DELETE"
		});
	},
	__getAutocompleteOption() {
		return request({
			url: `product/autocomplete-option`,
			method: "GET"
		});
	},
	__createOption({ id, data }) {
		return request({
			url: `product/new/${id}/option`,
			method: "POST",
			data
		});
	},
	__updateOption({ id, optionId, data }) {
		return request({
			url: `product/${id}/option/${optionId}`,
			method: "PUT",
			data
		});
	},
	__removeOption({ id, optionId }) {
		return request({
			url: `product/${id}/${optionId}`,
			method: "DELETE"
		});
	},
}